import { supabase } from '../config/supabase';
import type { MapSettings } from './types';

function envString(key: keyof ImportMetaEnv): string {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    const v = import.meta.env[key];
    if (typeof v === 'string' && v) return v;
  }
  return '';
}

const defaults: MapSettings = {
  provider: 'google',
  googleApiKey: envString('VITE_GOOGLE_MAPS_API_KEY'),
};

export async function fetchMapSettings(): Promise<MapSettings> {
  try {
    const { data, error } = await supabase.rpc('get_map_settings');
    if (error || !data || typeof data !== 'object') {
      return defaults;
    }

    const v = data as Record<string, unknown>;
    return {
      provider: 'google',
      googleApiKey: String(v.google_maps_api_key || defaults.googleApiKey || ''),
    };
  } catch {
    return defaults;
  }
}

export function getActiveMapApiKey(settings: MapSettings): string {
  return settings.googleApiKey;
}

export function isMapConfigured(settings: MapSettings): boolean {
  return getActiveMapApiKey(settings).length > 0;
}
